'use client'

import Link from 'next/link'
import { usePathname, useSearchParams } from 'next/navigation'
import { useTranslations } from 'next-intl'

import { AuthRoutes } from '../../../App.constants'
import { BASE_PATH } from '../../../App.routes'
import { Button } from '../../../components/Button'
import { VenueLogo } from '../../../components/VenueLogo/VenueLogo'

interface Props {
  logoUrl?: string | null
  displayName?: string | null
  companyId?: string
}

export const ForbiddenContent = ({ logoUrl, displayName, companyId }: Props) => {
  const t = useTranslations('forbidden')

  const pathname = usePathname()
  const searchParams = useSearchParams()

  const currentSearchParams = searchParams.toString() ? `?${searchParams.toString()}` : ''
  const redirectPath = `${BASE_PATH}${pathname}${currentSearchParams}`

  const authParams = new URLSearchParams()
  authParams.set('redirectPath', redirectPath)
  authParams.set('origin', 'widget')
  authParams.set('redirectApp', 'widget')
  if (companyId) {
    authParams.set('companyId', companyId)
  }
  const authQueryString = authParams.toString()

  const loginURL = `${window.location.origin}${AuthRoutes.LOGIN}?${authQueryString}`
  const registerURL = `${window.location.origin}${AuthRoutes.REGISTER}?${authQueryString}`

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-6 px-4">
      <div className="flex flex-col items-center gap-4">
        {logoUrl && <VenueLogo logoUrl={logoUrl} displayName={displayName} />}
        {displayName && <h1 className="text-2xl font-medium text-text-primary">{displayName}</h1>}
      </div>

      <div className="flex flex-col items-center gap-2 text-center">
        <h2 className="text-2xl font-medium text-text-primary">{t('page-title')}</h2>
        <p className="text-text-secondary">{t('page-description')}</p>
      </div>

      <div className="mt-12 flex w-full max-w-96 flex-col gap-2">
        <Button asChild variant="default" className="w-full">
          <Link href={loginURL} className="w-full">
            {t('login-button')}
          </Link>
        </Button>
        <Button asChild variant="brand-outline" className="w-full">
          <Link href={registerURL} className="w-full">
            {t('register-button')}
          </Link>
        </Button>
      </div>
    </div>
  )
}
